import api from "@/services/api"
import { UserStatus } from "@/types/userStatus"

class ApiUserStatus {
	private get axios () { return api.getAxios() }

	public async userStatusList (): Promise<UserStatus[]> {
		const result = await this.axios.get("/userStatus")
		return result.data
	}

	public async userStatusSave (userStatus: UserStatus): Promise<string> { return (await this.axios.post("/userStatus", userStatus)).data }
	public async userStatusDelete (userStatus: UserStatus): Promise<void> { await this.axios.delete(`/userStatus/${userStatus.id}`) }
}

const apiUserStatus = new ApiUserStatus()
export default apiUserStatus
